import type { HomeStateData } from '@workspace/api-backend'
import { CheckRow } from '@workspace/ui/components/check-row'
import { cn } from '@workspace/ui/lib/utils'

/**
 * How complete the profile is, and exactly what is left.
 *
 * The remaining items come from the same server-side calculation that decides
 * the gate, so the list can never disagree with the percentage beside it.
 */
export function ProfileVisual({
  percent,
  threshold,
  nextSteps,
}: {
  percent: number
  threshold: number
  nextSteps: HomeStateData['profileNextSteps']
}) {
  return (
    <div className="rounded-xl border border-border/40 bg-card/40 px-5 py-4">
      <div className="mb-2 text-[13.5px] text-muted-foreground">
        <b className="font-semibold text-foreground">{percent}%</b> complete · {threshold}% unlocks
        your matched investors
      </div>
      <div className="mb-3.5 h-2 overflow-hidden rounded-full bg-input">
        <div
          className={cn(
            'h-full rounded-full transition-all',
            percent >= threshold ? 'bg-emerald-400' : 'bg-primary'
          )}
          style={{ width: `${Math.min(100, percent)}%` }}
        />
      </div>
      {nextSteps.length > 0 && (
        <>
          <div className="mb-1.5 text-[10.5px] font-semibold uppercase tracking-[0.13em] text-muted-foreground">
            What is missing
          </div>
          {nextSteps.map((step) => (
            <CheckRow key={step.key} tone="todo">
              {step.label}
            </CheckRow>
          ))}
        </>
      )}
    </div>
  )
}
